import React, {PropTypes} from 'react';
import FlatButton from 'material-ui/FlatButton';

export class ContentToolBar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    moveUp: PropTypes.bool.isRequired,
    moveDown: PropTypes.bool.isRequired,
    onMoveUp: PropTypes.func,
    onMoveDown: PropTypes.func,
    remove: PropTypes.func.isRequired
  };

  getStyle() {
    return {
      root: {
        textAlign: 'right'
      },
      button: {
        minWidth: 0,
        height: 34,
        lineHeight: 1,
        margin: 0,
        marginLeft: 15
      },
      buttonLabel: {
        padding: 0,
        textTransform: 'none',
        fontSize: 12,
        lineHeight: 1
      }
    };
  }

  componentWillMount() {
    this.style = this.getStyle();
  }

  render() {
    const {className, style, remove, moveUp, moveDown, onMoveUp, onMoveDown} = this.props;
    const buttonProps = {
      hoverColor: 'transperent',
      rippleColor: 'transperent',
      secondary: true,
      style: this.style.button,
      labelStyle: this.style.buttonLabel
    };

    return (
      <div className={className} style={Object.assign(this.style.root, style)}>
        {moveUp ? (<FlatButton label="Move Up" onClick={onMoveUp} {...buttonProps}/>) : null}
        {moveDown ? (<FlatButton label="Move Down" onClick={onMoveDown} {...buttonProps}/>) : null}
        <FlatButton label="Remove" onClick={remove} {...buttonProps}/>
      </div>
    );
  }
}

export default ContentToolBar;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/ContentToolBar.js